import { observer } from 'mobx-react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { promocodeStore } from '../../store/promocodeStore';
import { DEBOUNCE_TIME } from 'src/constants/main';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import './style.scss';

@observer
export default class PromocodesHeader extends Component<{}, {}> {
  handleSearch = (name: string) => {
    promocodeStore.setFilters({ name }, false);
  };

  render() {
    return (
      <div className="d-flex flex-row justify-content-between pr-4">
        <SearchInput
          value={promocodeStore.filters.name}
          onChangeText={this.handleSearch}
          loading={promocodeStore.pagination.loading}
          debounceDelay={DEBOUNCE_TIME.MEDIUM}
          withResetIcon
          customPlaceholder
          placeholder="txt_search"
          className="promocodes-header__search-input"
          inputClassName="px-3 color-dark text-size-16 family-medium"
        />
        <Link to={SCREENS.PROMOCODE_CREATE()}>
          <Button title={localeStore.t('add_new_button')} loading={promocodeStore.pagination.loading} />
        </Link>
      </div>
    );
  }
}
